import http from "../http-common";
import axios from "axios";

class VideoService {
  // ─── Token ──────────────────────────────────────────────────────────────────
  generateToken = (data) => http.post("/video/token", data);

  // Guest token — no auth required, served from /nl route
  generateGuestToken = ({ roomName, displayName }) =>
    axios.post(process.env.VUE_APP_API_URL + "/nl/video/guest-token", { roomName, displayName });

  // ─── Rooms ──────────────────────────────────────────────────────────────────
  createRoom = () => http.post("/video/rooms");

  getActiveRooms = () => http.get("/video/active-rooms");

  getRoom = (roomId) => http.get(`/video/rooms/${roomId}`);

  getRoomStatus = (roomId) => http.get(`/video/rooms/${roomId}/status`);

  getPublicRoomStatus = (roomId) =>
    axios.get(`${process.env.VUE_APP_API_URL}/nl/video/rooms/${roomId}/status`);

  // ─── Participant lifecycle ───────────────────────────────────────────────────
  leaveRoom = (roomId, participantId) =>
    http.post(`/video/rooms/${roomId}/participants/${participantId}/leave`);

  guestLeaveRoom = (roomId, participantId) =>
    axios.post(`${process.env.VUE_APP_API_URL}/nl/video/rooms/${roomId}/participants/${participantId}/leave`);

  // ─── Recording (authenticated — used inside the meeting) ────────────────────
  startRecording = (roomId, roomName) =>
    http.post(`/video/rooms/${roomId}/recording/start`, { roomName });

  stopRecording = (roomId, egressId) =>
    http.post(`/video/rooms/${roomId}/recording/stop`, { egressId });

  getRecordings = (roomId) =>
    http.get(`/video/rooms/${roomId}/recordings`);

  downloadRecording = (roomId, recordingId) =>
    http.get(`/video/rooms/${roomId}/recordings/${recordingId}/download`);

  // ─── Recording by UUID — used in convo message card (authenticated staff only) ─
  getRecordingsByUuid = (roomUuid) =>
    http.get(`/video/rooms/${roomUuid}/recordings/by-uuid`);

  downloadRecordingByUuid = (roomUuid, recordingId) =>
    http.get(`/video/rooms/${roomUuid}/recordings/${recordingId}/download/by-uuid`);

  // ─── Admin controls ─────────────────────────────────────────────────────────
  muteParticipant = (roomId, peerId) =>
    http.post(`/video/rooms/${roomId}/participants/${peerId}/mute`);

  unmuteParticipant = (roomId, peerId) =>
    http.post(`/video/rooms/${roomId}/participants/${peerId}/unmute`);

  kickParticipant = (roomId, peerId) =>
    http.delete(`/video/rooms/${roomId}/participants/${peerId}`);

  // ─── End meeting (admin only) ────────────────────────────────────────────────
  endMeeting = (roomId) =>
    http.post(`/video/rooms/${roomId}/end`);

  // ─── Waiting room admission (host only) ──────────────────────────────────────
  admitGuest = (roomName, identity) =>
    http.post('/video/waiting-room/admit', { roomName, identity });

  denyGuest = (roomName, identity) =>
    http.post('/video/waiting-room/deny', { roomName, identity });

  // ─── Patient request (no auth) ───────────────────────────────────────────────
  patientRequest = ({ roomName, identity, displayName, phone, email }) =>
    axios.post(`${process.env.VUE_APP_API_URL}/nl/video/rooms/${roomName}/patient-request`, {
      identity, displayName, phone, email,
    });

  // ─── Room client summary ─────────────────────────────────────────────────────
  getRoomClientSummary = (roomId) =>
    http.get(`/video/rooms/${roomId}/client-summary`);
}

export default new VideoService();
